import { Alert, Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { useSampleSet } from '../../../../../contexts/SampleSetContext';
import { ResultType } from '../../../../../enums';
import HydraAnalytesTabRouter from '../../../../../pages/experiments/resultsAnalysis/hydra/HydraAnalytesTabRouter';
import IdAnalytesTab from '../../../../../pages/experiments/resultsAnalysis/id/IdAnalytesTab';
import MwmineFeaturesTab from '../../../../../pages/experiments/resultsAnalysis/mwmineFeatures/MwmineFeaturesTab';
import PeptidesAnalytesTab from '../../../../../pages/experiments/resultsAnalysis/peptides/PeptidesAnalytesTab';
import QuantAnalytesTab from '../../../../../pages/experiments/resultsAnalysis/quant/QuantAnalytesTab';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/analytes'
)({
  staticData: { ddViewName: 'experiments-analytes-tab' },
  component: AnalytesRouteComponent,
});

function AnalytesRouteComponent() {
  const { selectedJob, selectedJobId } = useSampleSet();

  if (!selectedJobId) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          minHeight: '300px',
        }}
      >
        <Alert severity="info" sx={{ textAlign: 'center' }}>
          No inference runs available, upload samples and apply a program to
          analyze
        </Alert>
      </Box>
    );
  }

  switch (selectedJob?.result_type) {
    case ResultType.HYDRA:
    case ResultType.ID_PARQUET:
      return <HydraAnalytesTabRouter />;
    case ResultType.ID:
      return <IdAnalytesTab />;
    case ResultType.PEPTIDES:
      return <PeptidesAnalytesTab />;
    case ResultType.MWMINE_FEATURES:
      return <MwmineFeaturesTab />;
    default:
      return <QuantAnalytesTab />;
  }
}
